import styled from 'styled-components'
import { bp } from 'lib/core/resources/helpers/styled'

const galleryWidth = '460px'

export const Container = styled.div`
  > div {
    width: ${galleryWidth};
    margin: 0 auto;
    padding-bottom: 100%;
    background: ${props => props.theme.palette.general.light} no-repeat 50% 0 / contain;
    ${bp('lg')`
      width: 348px;
    `}
  }
`
